import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const NIVELES_ACADEMICOS_CONST = 'nivelesAcademicos';
export const NIVELES_ACADEMICOS_API = 'niveles_academicos';

export const allNivelesAcademicosService = async (params) => {
  const res = await axios.get(`${baseUrl}/${NIVELES_ACADEMICOS_API}`, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveNivelesAcademicosService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(
      `${baseUrl}/${NIVELES_ACADEMICOS_API}/${id}`,
      data,
      { headers: token({}) },
    );
  } else {
    res = await axios.post(`${baseUrl}/${NIVELES_ACADEMICOS_API}`, data, {
      headers: token({}),
    });
  }
  return res;
};

export const oneNivelesAcademicosService = async (id) => {
  const res = await axios.get(`${baseUrl}/${NIVELES_ACADEMICOS_API}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteNivelesAcademicosService = async (id) => {
  const res = await axios.delete(`${baseUrl}/${NIVELES_ACADEMICOS_API}/${id}`, {
    headers: token({}),
  });
  return res;
};
